import { Box, Grid, Typography, IconButton, Menu, MenuItem } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { GetData, PostData } from '../../controls/helpers/requests';
import { getEnvVariable } from '../../../modules/environmentalList';
import ReusableCard from './ReusableCard';
import SortIcon from '@material-ui/icons/Sort';
import FilterListIcon from '@material-ui/icons/FilterList';
import { AssignmentTurnedIn, Info as InfoIcon } from '@material-ui/icons';
import DefaultSettings from '../../controls/components/settings';
import Pagination from '@material-ui/lab/Pagination';
import Breadcrumbs from '../../controls/components/breadcrumbs';



const breadcrumbs = {
    type: 'breadcrumbs',
    items: [
        { "link": "Public Hub", "tab": 1, "materialicon": "public", href: getEnvVariable('InternalBasepath'), className: 'breadcrumb-item text-dark', class: 'text-dark' },
        { "link": "User Approvals", "materialicon": "assignment_turned_in", className: 'breadcrumb-item text-dark', class: 'text-dark' }
    ]
}

export default function CompanyApprovals() {
    const [data, setData] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [sortOrder, setSortOrder] = useState('');
    const [filterStatus, setFilterStatus] = useState('');
    const [anchorElSort, setAnchorElSort] = useState(null);
    const [anchorElFilter, setAnchorElFilter] = useState(null);
    const [showActions, setShowActions] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(20);

    useEffect(() => {
        handleData(currentPage, pageSize);
    }, [currentPage, pageSize]);

    const handleData = (page = 1, pageSize = 20) => {
        let Profile = localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')) : {};
        let url = getEnvVariable('MasterAdmin') + `/api/SelfRegistration/Owner/GetAllCompanyRegistrationsData?Page=${page - 1}&PageSize=${pageSize}`;
        if (Profile && (getEnvVariable('AccessPortal') === 'I')) 
        url = getEnvVariable('MasterAdmin') + `/api/SelfRegistration/Admin/GetAllRegistrationsData?Page=${page - 1}&PageSize=${pageSize}`;
        GetData(url).then((res) => {
            if (res && res) {
                setData(res);
                setTotalItems(res.length); // Assuming the API returns totalItems
            }
        });
    };

    useEffect(() => {
        let Profile = localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')) : {};
        if (Profile && (getEnvVariable('AccessPortal') === 'E')) {
            setShowActions(true);
        } else {
            setShowActions(false);
        }
    }, []);

    const handleSortChange = (order) => {
        setSortOrder(order);
        const sortedData = [...data].sort((a, b) => {
            if (order === 'CreatedByName') {
                return a.FirstName.localeCompare(b.CreatedByName);
            } else if (order === 'CreatedOn') {
                return new Date(a.CreatedOn) - new Date(b.CreatedOn);
            }
            return 0;
        });
        setData(sortedData);
        setAnchorElSort(null);
    };

    const handleFilterChange = (status) => {
        setFilterStatus(status);
        setAnchorElFilter(null);
    };

    const handleSortMenuOpen = (event) => {
        setAnchorElSort(event.currentTarget);
    };

    const handleFilterMenuOpen = (event) => {
        setAnchorElFilter(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorElSort(null);
        setAnchorElFilter(null);
    };

    const handleActions = (item, action) => {
        let isApprove = action === 'A' ? true : false;
        let url = getEnvVariable('MasterAdmin') + `/api/SelfRegistration/Owner/${isApprove ? 'Approve' : 'Deny'}/${item.Id}`;
        PostData(url).then((res) => {
            if (res && res.error)
                if (DefaultSettings.getAlert() != null)
                    DefaultSettings.getAlert().show(res.message, 'error');
                else {
                    if (DefaultSettings.getAlert() != null)
                        DefaultSettings.getAlert().show(res.message, 'success');
                }
            handleData();
        }).catch((err) => {
            console.log(err);
        });
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    // Filter data based on filterStatus
    const filteredData = filterStatus ? data.filter(item => item.RegistrationStatus === filterStatus) : data;

    return (
        <Box className='application-border my-1' style={{ height: '82vh' }}>
            <Box className='application-border my-1 p-1 d-flex justify-content-between align-items-center mb-2'>
                {/* <Breadcrumbs {...breadcrumbs} /> */}
                {/* <Breadcrumbs {...breadcrumbs} className="m-1" /> */}
                <Typography variant="body1" style={{ flexGrow: 1 }}><AssignmentTurnedIn />{getEnvVariable('AccessPortal') === 'I' ? 'Company Approval Users' : 'User Approvals'}</Typography>
                {filteredData.length > 0 && (
                    <>
                        <IconButton onClick={handleSortMenuOpen} size='small' color='primary'>
                            <SortIcon />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElSort}
                            keepMounted
                            open={Boolean(anchorElSort)}
                            onClose={handleMenuClose}
                        >
                            <MenuItem onClick={() => handleSortChange('CreatedByName')}>Name</MenuItem>
                            <MenuItem onClick={() => handleSortChange('CreatedOn')}>Created On</MenuItem>
                        </Menu>
                        <Box className='p-1' />
                        <IconButton onClick={handleFilterMenuOpen} size='small' color='primary'>
                            <FilterListIcon />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElFilter}
                            keepMounted
                            open={Boolean(anchorElFilter)}
                            onClose={handleMenuClose}
                        >
                            <MenuItem onClick={() => handleFilterChange('')}>All</MenuItem>
                            <MenuItem onClick={() => handleFilterChange('A')}>Approved</MenuItem>
                            <MenuItem onClick={() => handleFilterChange('D')}>Denied</MenuItem>
                            <MenuItem onClick={() => handleFilterChange('P')}>Pending</MenuItem>
                        </Menu>
                    </>
                )}
            </Box>
            {filteredData.length > 0 ? (
                <>
                    <Box className='application-border-grey' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', height: '65vh', overflow: 'auto', margin: 5 }}>
                        {filteredData.map((item) => (
                            <Box key={item.id} style={{ flex: '1 1 calc(20% - 10px)', margin: '2px' }}>
                                <ReusableCard showActions={showActions} item={item} handleActions={handleActions} />
                            </Box>
                        ))}
                    </Box>
                    <Pagination
                        count={Math.ceil(totalItems / pageSize)}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="primary"
                        style={{ marginTop: '10px', display: 'flex', justifyContent: 'center' }}
                    />
                </>
            ) : (
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%">
                    <InfoIcon style={{ fontSize: 40 }} />
                    <Typography variant="body1">No approval requests at this time.</Typography>
                </Box>
            )}
        </Box>
    );
}